export default __webpack_public_path__ + "static/media/rolf.e672010f.jpg";